import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSoundcloudComponent } from './simple-icons-soundcloud.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSoundcloudComponent ],
    exports:      [ SimpleIconsSoundcloudComponent ],
    bootstrap:    []
})
export class SimpleIconsSoundcloudModule {}
